export class StoreErrorHandler {
  public static handleError(error: any) {
    console.error(error);
  }
}
